import { memo } from 'react'

import { AnimatedSpinner } from '../../../../components/AnimatedSpinner'

const TwinSpinner: React.FC = memo(() => {
  return (
    <div className="bg-white rounded-full w-12 h-12 flex items-center justify-center">
      <AnimatedSpinner className="text-black" />
    </div>
  )
})

export { TwinSpinner }
